(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    class ShowMoreManager {
  constructor() {
    this.init();
  }

  init() {
    // Run after everything loads
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.setupShowMoreButtons();
        }, 300);
      });
    } else {
      setTimeout(() => {
        this.setupShowMoreButtons();
      }, 300);
    }

    // Handle Shopify section loads
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        this.setupShowMoreButtons();
      }, 300);
    });
    
    // Handle variant changes
    document.addEventListener('variant:changed', () => {
      setTimeout(() => {
        this.setupShowMoreButtons();
      }, 300);
    });
  }

  setupShowMoreButtons() {
    console.log('Setting up show more buttons...');
    
    const contentElements = document.querySelectorAll('[id^="content-"]');
    console.log('Found content elements:', contentElements.length);
    
    contentElements.forEach(contentElement => {
      const blockId = contentElement.id.replace('content-', '');
      const btnElement = document.getElementById(`btn-${blockId}`);
      
      if (!btnElement) {
        console.log('No button found for:', blockId);
        return;
      }
      
      console.log('Processing:', blockId);
      
      // Force line-clamp initially
      contentElement.style.display = '-webkit-box';
      contentElement.style.webkitLineClamp = '2';
      contentElement.style.webkitBoxOrient = 'vertical';
      contentElement.style.overflow = 'hidden';
      contentElement.classList.remove('expanded');
      
      // Check if content needs show more button
      const checkContentHeight = () => {
        // Get scrollHeight (full content height)
        const scrollHeight = contentElement.scrollHeight;
        
        // Get line height
        const lineHeight = parseInt(window.getComputedStyle(contentElement).lineHeight) || 20;
        
        // 2 lines height
        const twoLineHeight = lineHeight * 2;
        
        console.log({
          blockId,
          scrollHeight,
          lineHeight,
          twoLineHeight,
          needsButton: scrollHeight > twoLineHeight + 2
        });
        
        // Show button if content is taller than 2 lines
        if (scrollHeight > twoLineHeight + 2) {
          btnElement.style.display = 'inline-flex';
          console.log('Showing MORE button for:', blockId);
        } else {
          btnElement.style.display = 'none';
          console.log('Hiding button for:', blockId);
        }
      };
      
      // Check multiple times for accuracy
      setTimeout(checkContentHeight, 100);
      setTimeout(checkContentHeight, 300);
      setTimeout(checkContentHeight, 500);
      setTimeout(checkContentHeight, 1000);
      
      // Check on window resize
      window.addEventListener('resize', () => {
        setTimeout(checkContentHeight, 100);
      });
      
      // Remove existing listeners and add new one
      const newBtn = btnElement.cloneNode(true);
      btnElement.parentNode.replaceChild(newBtn, btnElement);
      
      // Add click listener
      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = contentElement.classList.contains('expanded');
        const btnText = newBtn.querySelector('.btn-text');
        
        if (isExpanded) {
          // Show less
          contentElement.classList.remove('expanded');
          contentElement.style.display = '-webkit-box';
          contentElement.style.webkitLineClamp = '2';
          contentElement.style.webkitBoxOrient = 'vertical';
          contentElement.style.overflow = 'hidden';
          
          newBtn.classList.remove('expanded');  // Remove expanded class
          btnText.textContent = 'Show More';
          // Arrow points DOWN (default - no rotation)
        } else {
          // Show more
          contentElement.classList.add('expanded');
          contentElement.style.display = 'block';
          contentElement.style.webkitLineClamp = 'unset';
          contentElement.style.overflow = 'visible';
          
          newBtn.classList.add('expanded');  // Add expanded class
          btnText.textContent = 'Show Less';
          // Arrow points UP (rotated 180deg by CSS)
        }
      });
    });
  }
}

// Initialize
new ShowMoreManager();
  } catch(e) { console.error(e); }
})();

})();
